module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-83.89e38674.svg";